import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const url = supabaseUrl;
const key = supabaseKey;

export const cloudConfigured = Boolean(url && key && !url.includes('your-project-ref'));

export const supabase = cloudConfigured
  ? createClient(url, key, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'recall.auth',
      },
      realtime: { params: { eventsPerSecond: 2 } },
    })
  : null;
